export const login = {
    validate: value => new RegExp(/^([a-zA-Z0-9_]+)$/).test(value)
  };
  